import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import FlightSegmentView from './FlightSegmentView';


class TableHeader extends React.Component {
    componentWillMount() {}

    render() {
        const {
            dateFrom, withThead, flightData, changeFlightModal, dayDiff, history,
        } = this.props;
        const printedDate = moment(dateFrom);
        const color = {
            Available: 'rgba(25, 126, 6, 1)',
            'Limited Seats': 'rgba(206, 147, 6, 1)',
            Full: 'rgba(180, 23, 0, 1)',
            none: '#222',
        };
        const elements = (
            <tr>
                <th
                    rowSpan={withThead ? 2 : 1}
                    style={{ width: '150px !important', textAlign: 'center', height: 47 }}
                >
                    Room
                    {withThead ? <br /> : ' '}
                    Type
                </th>
                <th style={{ width: 30 }}>#</th>

                {_.times(Math.round(dayDiff / 3.5), (i) => {
                    const currentDate = printedDate.clone();
                    const returnVal = (<th
                        style={{ width: 40, textAlign: 'center' }}
                        colSpan={(currentDate.format('dd') === 'Fr' ? 3 : 4)}
                        key={i}
                    >
                        <FlightSegmentView
                            colorList={color}
                            flightData={flightData}
                            printedDate={currentDate.format('YYYY-MM-DD')}
                            changeFlightModal={changeFlightModal}
                            history={history}
                        />
                    </th>);
                    printedDate.add(printedDate.format('dd') === 'Mo' ? 4 : 3, 'days');
                    return returnVal;
                })
                }
            </tr>
        );
        if (withThead) {
            return (
                <thead style={{ backgroundColor: '#fff' }}>
                    {elements}
                </thead>
            );
        }
        return elements;
    }
}

TableHeader.propTypes = {
    dateFrom: PropTypes.objectOf(moment).isRequired,
    withThead: PropTypes.bool.isRequired,
    flightData: PropTypes.bool.isRequired,
    changeFlightModal: PropTypes.func.isRequired,
    dayDiff: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
};

export default TableHeader;
